import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, AfterViewInit } from "@angular/core";
import { OptionToCloseRollCell } from "./option-to-close-roll-cell.component";
import { AppService } from "@irb/app.service";
import { IrbClientsEvents } from "@irb/irb-clients/irb-clients.events";

@Component({ standalone: false,
    selector: 'option-to-close-roll-cell-renderer',
    templateUrl: './option-to-close-roll-cell.html',
    styleUrls: ["./option-to-close-roll-cell.scss"],
})
export class OptionToCloseRollCellRenderer extends OptionToCloseRollCell implements ICellRendererAngularComp, AfterViewInit {

    constructor(private as: AppService) {
        super();
    }
    
    agInit(params: any): void {
        this.params = params;
        this.componentParent = this.params.context.componentParent;
        this.load();
    }

    ngAfterViewInit() {
        this.dropdownFilter.setDisabled((this.params.isDisabled) ? this.params.isDisabled() : false);
    }

    refresh(): boolean {
        this.dropdownFilter?.setDisabled((this.params.isDisabled) ? this.params.isDisabled() : false);
        return true;
    }

    onOptionChange() {
        if (this.selectedValue.value === 'VIEW_CHAIN' || this.selectedValue.value === 'OPTION_CHAIN') {
            const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
            this.componentParent.editedRowIndex = rowIndex;

            this.as.fireEvent(IrbClientsEvents.SHOW_OPTION_CHAINS_DIALOG, {
                data: {
                    action: 'ROLL_COVER_CALL', 
                    underlyingSymbol: this.params.data.underlyingSymbol, 
                    chainType: this.getChainType(),
                    isChainTypeDisable: false,
                    isTrayVisible: false
                }
            });

            this.selectedValue = this.options[0];
            this.dropdownFilter.setValue(this.selectedValue);
        } else {
            this.params.data.optionSelectionMode = this.selectedValue.value;
            this.params.data.optionSymbol = null;
            this.componentParent.loadGrid();
        }
    }

    getChainType() {
        let chainType: string = "ALL";
        if (this.params.data.optionSelectionMode) {
            switch(this.params.data.optionSelectionMode) {
                case 'ALL_CALLS':
                    chainType = "CALL";
                    break;
                case 'ALL_PUTS':
                    chainType = "PUT";
                    break;
            }
        }
        return chainType;
    }
}
